module.exports = __webpack_public_path__ + "static/media/2012_nov_miles.6380a38a.jpg";